export const categories = [
  { slug: 'lianai', name: '恋爱', icon: 'ri-heart-line', description: '甜蜜浪漫的恋爱故事' },
  { slug: 'juqing', name: '剧情', icon: 'ri-file-text-line', description: '引人入胜的剧情佳作' },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line', description: '扣人心弦的悬疑谜题' },
  { slug: 'dongzuo', name: '动作', icon: 'ri-flashlight-line', description: '热血沸腾的动作场面' },
  { slug: 'qihuan', name: '奇幻', icon: 'ri-magic-line', description: '天马行空的奇幻世界' },
  { slug: 'xiaoyuan', name: '校园', icon: 'ri-building-4-line', description: '青春洋溢的校园日常' },
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line', description: '轻松愉快的搞笑作品' },
  { slug: 'zhiyu', name: '治愈', icon: 'ri-mental-health-line', description: '温暖人心的治愈故事' },
];

export const comics = [
  {
    id: 1,
    title: '某天成为公主',
    author: 'Spoon',
    category: 'lianai',
    categoryName: '恋爱',
    subCategory: 'qihuan',
    subCategoryName: '奇幻',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20beautiful%20princess%20in%20an%20elegant%20gown%20with%20golden%20hair%2C%20soft%20romantic%20atmosphere%2C%20pastel%20colors%2C%20watercolor%20effect%2C%20anime%20art%20style%2C%20clean%20simple%20background%20with%20light%20gradient%2C%20cute%20and%20dreamy&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '一觉醒来，我竟然变成了小说中的公主？!而且还是一个注定要迎来悲惨结局的配角公主。为了改变命运，我必须在这个陌生的世界里努力活下去。',
    rating: 9.5,
    views: 1258000,
    chapters: 168,
    status: '连载中',
    updatedAt: '2026-08-03',
    tags: ['穿越', '逆袭', '甜宠'],
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 2,
    title: '恶女重生',
    author: 'YUJU',
    category: 'juqing',
    categoryName: '剧情',
    subCategory: 'lianai',
    subCategoryName: '恋爱',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20portrait%20of%20a%20fierce%20elegant%20woman%20with%20long%20dark%20hair%20in%20royal%20attire%2C%20dramatic%20lighting%2C%20intense%20expression%2C%20anime%20art%20style%2C%20red%20and%20dark%20color%20palette%2C%20clean%20simple%20background&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '被最信任的人背叛而死，睁开眼却回到了十年前。这一次，我不会再重蹈覆辙。所有的背叛者，都将付出代价。',
    rating: 9.3,
    views: 980000,
    chapters: 142,
    status: '连载中',
    updatedAt: '2026-08-03',
    tags: ['重生', '复仇', '逆袭'],
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 3,
    title: '全知读者视角',
    author: 'sing N song',
    category: 'dongzuo',
    categoryName: '动作',
    subCategory: 'qihuan',
    subCategoryName: '奇幻',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20young%20man%20in%20a%20black%20coat%20with%20sharp%20eyes%2C%20standing%20in%20a%20post%20apocalyptic%20urban%20setting%2C%20action%20oriented%2C%20dramatic%20composition%2C%20anime%20art%20style%2C%20dark%20tones%20with%20neon%20accents&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '我是唯一一个读完了那部连载了3149话小说的人。当小说中的世界变成了现实，我成为了唯一知道这个世界所有秘密的人。',
    rating: 9.8,
    views: 2350000,
    chapters: 210,
    status: '连载中',
    updatedAt: '2026-08-04',
    tags: ['末世', '系统', '热血'],
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 4,
    title: '神之塔',
    author: 'SIU',
    category: 'dongzuo',
    categoryName: '动作',
    subCategory: 'qihuan',
    subCategoryName: '奇幻',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20art%20style%20illustration%20of%20a%20mysterious%20tower%20with%20a%20boy%20climbing%20upward%2C%20fantasy%20elements%2C%20bright%20colors%2C%20adventure%20theme%2C%20anime%20style%2C%20clean%20and%20dynamic%20composition&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '只要登上塔顶，就能得到任何想要的东西。少年夜为了追寻唯一的伙伴蕾哈尔，开始了攀登神秘巨塔的旅程。',
    rating: 9.6,
    views: 1890000,
    chapters: 550,
    status: '连载中',
    updatedAt: '2026-08-02',
    tags: ['冒险', '热血', '友情'],
    isHot: true,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 5,
    title: '梨泰院Class',
    author: '赵光真',
    category: 'juqing',
    categoryName: '剧情',
    subCategory: 'dongzuo',
    subCategoryName: '动作',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20determined%20young%20man%20with%20short%20hair%20in%20a%20casual%20outfit%20standing%20in%20front%20of%20a%20restaurant%2C%20urban%20night%20scene%2C%20dramatic%20lighting%2C%20anime%20art%20style%2C%20realistic%20tone&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '因一场意外失去了父亲，少年朴世路发誓要向害死父亲的仇人复仇。在梨泰院开设餐馆，一步步实现自己的商业帝国梦想。',
    rating: 9.4,
    views: 1560000,
    chapters: 148,
    status: '已完结',
    updatedAt: '2026-07-15',
    tags: ['复仇', '创业', '励志'],
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 6,
    title: '我的ID是江南美人',
    author: '淇萌',
    category: 'xiaoyuan',
    categoryName: '校园',
    subCategory: 'lianai',
    subCategoryName: '恋爱',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20portrait%20of%20a%20beautiful%20college%20girl%20with%20long%20wavy%20hair%2C%20natural%20makeup%2C%20warm%20smile%2C%20campus%20background%2C%20romantic%20and%20fresh%20atmosphere%2C%20anime%20art%20style%2C%20soft%20lighting&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '因为外貌被人嘲笑，她选择了整容来改变人生。进入大学后，她以为可以重新开始，却不料遇到了一个能看穿她一切秘密的男生。',
    rating: 9.2,
    views: 1120000,
    chapters: 80,
    status: '已完结',
    updatedAt: '2026-06-20',
    tags: ['校园', '恋爱', '成长'],
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 7,
    title: '女神降临',
    author: '猫咪',
    category: 'xiaoyuan',
    categoryName: '校园',
    subCategory: 'lianai',
    subCategoryName: '恋爱',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20art%20style%20illustration%20of%20a%20gorgeous%20girl%20with%20perfect%20makeup%20transforming%20from%20plain%20to%20stunning%2C%20fashion%20and%20beauty%20theme%2C%20glamorous%20atmosphere%2C%20anime%20style%2C%20sparkling%20effects&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '对外貌极度自卑的林珠京，通过化妆技术摇身一变成为校园女神。两个极致帅气的男生闯入她的生活，她的秘密还能维持多久？',
    rating: 9.3,
    views: 2100000,
    chapters: 165,
    status: '已完结',
    updatedAt: '2026-05-10',
    tags: ['化妆', '恋爱', '校园'],
    isHot: true,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 8,
    title: '追踪者',
    author: '崔圭硕',
    category: 'xuanyi',
    categoryName: '悬疑',
    subCategory: 'dongzuo',
    subCategoryName: '动作',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20dark%20illustration%20of%20a%20detective%20in%20a%20trench%20coat%20holding%20a%20flashlight%20in%20a%20foggy%20alley%2C%20noir%20atmosphere%2C%20thriller%20mood%2C%20anime%20art%20style%2C%20shadows%20and%20contrast&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '一起离奇的连环失踪案，将所有线索指向了一个神秘组织。刑警韩泰柱在追查真相的过程中，发现自己竟与案件有着千丝万缕的联系。',
    rating: 9.1,
    views: 780000,
    chapters: 96,
    status: '连载中',
    updatedAt: '2026-08-01',
    tags: ['悬疑', '推理', '犯罪'],
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 9,
    title: '僵尸校园',
    author: '朱东根',
    category: 'xuanyi',
    categoryName: '悬疑',
    subCategory: 'dongzuo',
    subCategoryName: '动作',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20style%20illustration%20of%20students%20trapped%20in%20a%20dark%20school%20corridor%20with%20emergency%20lights%2C%20zombie%20apocalypse%20theme%2C%20tense%20atmosphere%2C%20anime%20art%20style%2C%20gritty%20tones&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    description: '孝山高中突然爆发了致命的僵尸病毒，被困在校园里的学生们必须在资源耗尽之前找到逃生的方法。每一次选择都关乎生死。',
    rating: 9.0,
    views: 1650000,
    chapters: 130,
    status: '连载中',
    updatedAt: '2026-07-28',
    tags: ['丧尸', '生存', '校园'],
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 10,
    title: '社内相亲',
    author: '楷灿',
    category: 'gaoxiao',
    categoryName: '搞笑',
    subCategory: 'lianai',
    subCategoryName: '恋爱',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20young%20couple%20in%20office%20attire%20sharing%20a%20funny%20romantic%20moment%2C%20comedy%20vibe%2C%20bright%20and%20cheerful%2C%20anime%20art%20style%2C%20pastel%20colors&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    description: '代替闺蜜去相亲，结果相亲对象竟然是自己公司的社长！？更离谱的是，社长居然说「我们结婚吧」——这段办公室恋情还能更戏剧化吗？',
    rating: 9.4,
    views: 1980000,
    chapters: 125,
    status: '已完结',
    updatedAt: '2026-04-30',
    tags: ['搞笑', '恋爱', '办公室'],
    isHot: true,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 11,
    title: '甜蜜的梦',
    author: 'Lee Hye',
    category: 'zhiyu',
    categoryName: '治愈',
    subCategory: 'lianai',
    subCategoryName: '恋爱',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20soft%20illustration%20of%20a%20girl%20sitting%20in%20a%20cozy%20cafe%20with%20warm%20sunlight%20streaming%20through%20windows%2C%20healing%20and%20gentle%20atmosphere%2C%20anime%20art%20style%2C%20cream%20and%20beige%20tones&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    description: '患有失眠症的设计师允儿，在一家深夜咖啡馆遇到了神秘的面包师。每个夜晚的相遇，都像是命运精心编织的甜蜜梦境。',
    rating: 9.0,
    views: 650000,
    chapters: 72,
    status: '连载中',
    updatedAt: '2026-08-04',
    tags: ['治愈', '美食', '慢热'],
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
  {
    id: 12,
    title: '该死的家伙',
    author: '金泰亨',
    category: 'dongzuo',
    categoryName: '动作',
    subCategory: 'xuanyi',
    subCategoryName: '悬疑',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20style%20illustration%20of%20a%20muscular%20man%20with%20scars%20in%20a%20fight%20stance%2C%20street%20fighter%20theme%2C%20intense%20and%20gritty%2C%20anime%20art%20style%2C%20dark%20urban%20backdrop&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    description: '前特种兵金俊浩退役后想过平凡的生活，但过去的阴影却不断追上来。为了保护珍视的人，他不得不再次拿起武器。',
    rating: 9.2,
    views: 890000,
    chapters: 105,
    status: '连载中',
    updatedAt: '2026-08-02',
    tags: ['动作', '黑帮', '硬汉'],
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 13,
    title: '恋爱革命',
    author: '232',
    category: 'gaoxiao',
    categoryName: '搞笑',
    subCategory: 'xiaoyuan',
    subCategoryName: '校园',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20funny%20illustration%20of%20a%20high%20school%20boy%20with%20exaggerated%20expressions%20confessing%20love%2C%20comedy%20romance%2C%20colorful%20and%20energetic%2C%20anime%20art%20style%2C%20school%20setting&width=600&height=800&seq=comic-cover-13&orientation=portrait',
    description: '高中生公主琳为了追求心仪的女生，开始了一场轰轰烈烈的恋爱革命。朋友的助攻、情敌的阻挠，各种爆笑又感动的青春故事即将上演。',
    rating: 9.3,
    views: 1480000,
    chapters: 200,
    status: '已完结',
    updatedAt: '2026-03-15',
    tags: ['搞笑', '校园', '恋爱'],
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 14,
    title: '魔法师的重生',
    author: '郑贤宇',
    category: 'qihuan',
    categoryName: '奇幻',
    subCategory: 'dongzuo',
    subCategoryName: '动作',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20style%20illustration%20of%20a%20powerful%20mage%20with%20glowing%20magic%20circles%20and%20flowing%20robes%2C%20epic%20magical%20atmosphere%2C%20anime%20art%20style%2C%20mystical%20blue%20and%20purple%20tones&width=600&height=800&seq=comic-cover-14&orientation=portrait',
    description: '最强的魔法师在最后一战中陨落，却意外重生到了魔法被遗忘的世界。在这个末法时代，他将重新书写魔法的传奇。',
    rating: 9.1,
    views: 720000,
    chapters: 88,
    status: '连载中',
    updatedAt: '2026-08-04',
    tags: ['重生', '魔法', '升级'],
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
  {
    id: 15,
    title: '办公室秘密',
    author: '金敏秀',
    category: 'lianai',
    categoryName: '恋爱',
    subCategory: 'juqing',
    subCategoryName: '剧情',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20elegant%20illustration%20of%20a%20professional%20woman%20and%20man%20in%20business%20attire%20sharing%20a%20secret%20glance%20in%20a%20modern%20office%2C%20romantic%20chemistry%2C%20anime%20art%20style%2C%20sophisticated%20tone&width=600&height=800&seq=comic-cover-15&orientation=portrait',
    description: '新入职的职员与冷酷的上司之间不可告人的秘密关系。白天是上下级，夜晚却变成了完全不同的关系。这段危险的办公室恋情能否长久？',
    rating: 9.0,
    views: 850000,
    chapters: 95,
    status: '连载中',
    updatedAt: '2026-08-01',
    tags: ['恋爱', '职场', '秘密'],
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
  {
    id: 16,
    title: '极恶之徒',
    author: '李贤民',
    category: 'dongzuo',
    categoryName: '动作',
    subCategory: 'xuanyi',
    subCategoryName: '悬疑',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20style%20illustration%20of%20a%20mysterious%20antihero%20in%20a%20leather%20jacket%20in%20a%20rainy%20alleyway%2C%20crime%20noir%20aesthetic%2C%20anime%20art%20style%2C%20dark%20and%20moody&width=600&height=800&seq=comic-cover-16&orientation=portrait',
    description: '地下世界的传奇杀手决定金盆洗手，但组织怎么可能轻易放他离开？一场复仇与救赎的血色旅程就此展开。',
    rating: 9.2,
    views: 920000,
    chapters: 110,
    status: '连载中',
    updatedAt: '2026-07-30',
    tags: ['动作', '黑帮', '复仇'],
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
];

export const banners = [
  {
    id: 1,
    title: '全知读者视角',
    subtitle: '2026年度最受欢迎的韩漫大作',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20epic%20horizontal%20illustration%20of%20a%20heroic%20figure%20overlooking%20a%20destroyed%20cityscape%20at%20sunset%2C%20dramatic%20cinematic%20lighting%2C%20anime%20art%20style%2C%20warm%20golden%20and%20orange%20tones%2C%20clean%20background&width=1600&height=700&seq=banner-01&orientation=landscape',
    comicId: 3,
  },
  {
    id: 2,
    title: '社内相亲',
    subtitle: '甜到爆炸的办公室恋爱喜剧',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romantic%20horizontal%20illustration%20of%20a%20happy%20couple%20in%20office%20clothes%20walking%20hand%20in%20hand%20in%20a%20cherry%20blossom%20park%2C%20bright%20spring%20colors%2C%20anime%20art%20style%2C%20soft%20pastel%20tones&width=1600&height=700&seq=banner-02&orientation=landscape',
    comicId: 10,
  },
  {
    id: 3,
    title: '追踪者',
    subtitle: '悬疑推理烧脑巨作',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20style%20horizontal%20illustration%20of%20a%20detective%20standing%20in%20a%20dimly%20lit%20room%20with%20clues%20and%20photos%20on%20a%20board%2C%20noir%20atmosphere%2C%20anime%20art%20style%2C%20dark%20and%20mysterious&width=1600&height=700&seq=banner-03&orientation=landscape',
    comicId: 8,
  },
];

export const faqs = [
  {
    q: '韩国漫画网的漫画都是免费的吗？',
    a: '是的！我们致力于为所有韩漫爱好者提供完全免费的阅读体验。所有漫画资源均可在线阅读，无需支付任何费用。我们会持续更新最新热门韩漫资源。',
  },
  {
    q: '如何找到我想看的漫画？',
    a: '您可以通过首页的分类导航浏览不同题材的漫画，包括恋爱、剧情、悬疑、动作、奇幻、校园等多种类型。您也可以使用搜索功能直接查找漫画名称。',
  },
  {
    q: '漫画更新频率是怎样的？',
    a: '我们与韩国最新的漫画更新保持同步，热门漫画通常每周更新1至2次。首页的「最新更新」栏目会实时展示最新的漫画更新动态，让您不错过任何精彩内容。',
  },
  {
    q: '支持哪些设备阅读？',
    a: '韩国漫画网支持全平台阅读，无论是电脑、平板还是手机，都可以获得流畅的阅读体验。我们的响应式设计会自动适配不同的屏幕尺寸。',
  },
  {
    q: '如何收藏喜欢的漫画？',
    a: '您可以注册账号后使用收藏功能，将喜欢的漫画加入个人收藏夹，方便随时查看更新。我们目前正在开发更多个性化功能，敬请期待。',
  },
];